module.exports = __webpack_public_path__ + "img/PRIMAL-01.0f4e4a20.png";